import type { ComponentProps } from 'react';

// Not role="status": that implies aria-atomic="true" and would re-read every stacked banner on each change.
export const PageBannerRegion = (props: ComponentProps<'div'>) => (
  <div data-spellbook-name="page-banners" aria-live="polite" aria-atomic="false" {...props} />
);
